<template>
  <div>
    <el-row>
      <el-col :span="8">
        <div hideTitle>
          <UpdateIcon @click="handleClick"
                      height="120px"
                      width="120px"
          ></UpdateIcon>
        </div>
      </el-col>
      <el-col :span="16">
        <div hideTitle style="font-size: 14px;">
          <div style="margin: 6px;">
            <span style="color: rgb(154,154,154)">版本名称: </span>
            <span style="color: #000000">{{ value.versionName }}</span>
          </div>
          <div style="margin: 6px;">
            <span style="color: rgb(154,154,154)">版本编号: </span>
            <span style="color: #000000">{{ value.versionNo }}</span>
          </div>
          <div style="margin: 6px;">
            <span style="color: rgb(154,154,154)">版本大小: </span>
            <span style="color: #000000">{{ value.versionSize }} M</span>
          </div>
          <div style="margin: 6px;">
            <span style="color: rgb(154,154,154)">更新时间: </span>
            <span style="color: #000000">{{ simpleFormatterDate(value.updateDate) || '-'}}</span>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
  import UpdateIcon from "./UpdateIcon.vue";

  export default {
    props: {
      value: Object,
    },
    components: {UpdateIcon},
    data() {
      return {};
    },
    mounted() {
    },
    watch: {},
    methods: {
      handleClick() {

      }
    }
  };
</script>
<style>
</style>

